import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
// removed unused imports
import Header from "../../../components/Header";
import Swal from "sweetalert2";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";
import { setupManagementUrl } from "../../../config";
const base_url = setupManagementUrl.uri;
const SizeForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const initialValues = {
    name: props.data ? props.data.name : "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("name is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        name: values.name,
      };

      if (props.isEditing) {
        mutationData.id = props.data.id;
        mutationData.updatedBy = userId;
        if (props.data?.createdBy !== undefined && props.data?.createdBy !== null) {
          mutationData.createdBy = props.data.createdBy;
        }
      } else {
        mutationData.createdBy = userId;
      }

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateSizes" : "createSizes",
        mutationData,
        props.isEditing ? "sizes" : "size",
        base_url
      );
      if (response) {
        props.onClose();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Shoe size ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        }).then(() => {
          props.refetchData(); // Close the modal after the success message
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <Box
      m="20px"
      bgcolor="background.paper"
      p={3}
      //borderRadius={8}
      // boxShadow={3}
    >
      <Header
        title={
          props.isEditing ? "Edit shoe size" : "Create shoe size"
        }
        subtitle={
          props.isEditing
            ? "Edit an existing shoe size"
            : "Create a new shoe size"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Size *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
              />
              {/* <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Shoe Size *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.shoeSize}
                name="shoeSize"
                error={touched.shoeSize && !!errors.shoeSize}
                helperText={touched.shoeSize && errors.shoeSize}
              /> */}
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default SizeForm;
